import React from 'react';
import Flex from 'toolbox/src/components/Flex/Flex';
import ResetButton from 'components/ResetButton/ResetButton';
import SubmitButton from 'components/SubmitButton/SubmitButton';

interface ResetAndSubmitButtonProps {}

export const ResetAndSubmitButton: React.FC<ResetAndSubmitButtonProps> = ({
  children,
}) => {
  return (
    <Flex justifyContent="flex-end" mx={3}>
      <ResetButton>Reset</ResetButton>
      <SubmitButton>Save</SubmitButton>
    </Flex>
  );
};

export default ResetAndSubmitButton;
